import { LocalDate } from '@js-joda/core';

import { dateFormatter } from '@dreryk/react-common';

import { prescriptionTranslationKeys } from '../../../../../translations';
import { StyledPrescriptionTextView } from '../../prescriptionTextView.styled';

type IssuedFromTextViewProps = {
   readonly issuedFrom: LocalDate;
};

export const IssuedFromTextView = (props: IssuedFromTextViewProps): JSX.Element => {
   return (
      <StyledPrescriptionTextView
         testId={'issuedFrom'}
         compact
         label={prescriptionTranslationKeys.issueDate.issuedFrom}
      >
         {dateFormatter(props.issuedFrom)}
      </StyledPrescriptionTextView>
   );
};
